/**
 * Apex Mechanic Digital Theme Scripts
 */

document.addEventListener('DOMContentLoaded', function() {
  initHeaderScroll();
  initTabs();
  initShopifyCartWatcher();
});

/**
 * Adds styling to header on scroll
 */
function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 20) {
      header.classList.add('header-scrolled');
      header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.5)';
      header.style.background = 'rgba(13, 13, 15, 0.95)';
    } else {
      header.classList.remove('header-scrolled');
      header.style.boxShadow = 'none';
      header.style.background = 'rgba(13, 13, 15, 0.85)';
    }
  });
}

/**
 * Handle Glassmorphic Product Page Tabs
 */
function initTabs() {
  const tabsContainer = document.querySelector('.product-tabs-wrapper');
  if (!tabsContainer) return;

  const tabButtons = tabsContainer.querySelectorAll('.tab-btn');
  const tabPanels = tabsContainer.querySelectorAll('.tab-panel');

  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetPanelId = this.getAttribute('data-tab');

      // Deactivate all buttons & panels
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // Activate clicked button & corresponding panel
      this.classList.add('active');
      const targetPanel = tabsContainer.querySelector(`#${targetPanelId}`);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });
}

/**
 * Shopify Cart Watcher & AJAX updates
 */
function initShopifyCartWatcher() {
  // Fetch current cart to populate bubble on page load
  fetchCartCount();
}

/**
 * Fetch current item count in Shopify cart
 */
function fetchCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartBubble(cart.item_count);
    })
    .catch(error => {
      console.warn('Error fetching cart.js, might be in local preview environment:', error);
    });
}

/**
 * Update the header cart bubble
 * @param {number} count 
 */
function updateCartBubble(count) {
  const cartBubble = document.getElementById('CartCount');
  if (cartBubble) {
    cartBubble.textContent = count;
    if (count > 0) {
      cartBubble.style.display = 'flex';
      cartBubble.classList.add('bounce-animation');
      setTimeout(() => cartBubble.classList.remove('bounce-animation'), 400);
    } else {
      cartBubble.style.display = 'none';
    }
  }
}

/**
 * Add a list of items to the Shopify cart using AJAX
 * @param {Array<{id: number, quantity: number}>} items 
 * @returns {Promise}
 */
window.addMultipleItemsToCart = function(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Fetch updated cart to refresh header bubble
    fetchCartCount();
    return data;
  });
};
